export default {
  namespaced: true,
  state: {
    currentPage: 1,
    count: 0
  },
  actions: {
    async metric ({ dispatch, state }, data) {
      console.log(data)
      var endpoint = data.id ? data.id + '/' + data.url : data.url
      return dispatch('list', { basePath: 'api/metrics/' + endpoint, params: data.params }, { root: true })
        .then(response => {
          state.count = response.count
          state.currentPage = data.params.page
          return response.results
        })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.objects }
  }
}



// WEBPACK FOOTER //
// ./src/store/metrics.js